import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../../abstraction/auth.service';
import errors from '../../../utils/errorCodes';
import { CommerceOnboardingComponent } from '../commerce-profile/commerce-onboarding/commerce-onboarding.component';

@Component({
  selector: 'app-commerce-profile',
  templateUrl: './commerce-profile.component.html',
  styleUrls: ['./commerce-profile.component.scss'],
})
export class CommerceProfileComponent implements OnInit {
  apiKey = new FormControl('', []);
  apiSecret = new FormControl('', []);
  formGroup: FormGroup;
  hideApiSecret = true;
  successApiKeyCopy = false;
  successApiSecretCopy = false;
  commerceOnboarded: boolean;

  constructor(public authSvc: AuthService, private dialog: MatDialog) {
    this.formGroup = new FormGroup({
      accentColor: new FormControl('', []),
      logoUrl: new FormControl('', []),
      displayName: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.authSvc.commerceConfig.subscribe((commerceConfig) => {
      if (commerceConfig) {
        this.apiKey.setValue(commerceConfig.apiKey);
        this.apiSecret.setValue(commerceConfig.webhookSecret);
        this.formGroup.controls.displayName.setValue(commerceConfig.displayName);
        this.formGroup.controls.accentColor.setValue(commerceConfig.accentColor);
        this.formGroup.controls.logoUrl.setValue(commerceConfig.logoUrl);
      }
    });
    this.commerceOnboarded = Boolean(this.authSvc.getCommerceOnboarding());
  }

  getErrorMessage(input: string) {
    const keys = Object.keys(this.formGroup.controls[input].errors);
    if (keys.length === 0) {
      return '';
    }
    return errors[keys[0]];
  }

  enableCommerce() {
    this.dialog
      .open(CommerceOnboardingComponent, {
        panelClass: 'commerce-onboarding',
        maxWidth: '100vw',
      })
      .afterClosed()
      .subscribe((onboarded) => {
        if (onboarded) {
          this.authSvc.setCommerceOnboarding();
          this.commerceOnboarded = true;
        }
      });
  }
}
